import { Link } from "react-router-dom";
import { Phone, MessageSquareText } from "lucide-react";
import { PHONE_DISPLAY, TEL_HREF, SMS_HREF, LOGO_DARK } from "@/data/site";

export default function Hero() {
  return (
    <section className="relative bg-ink text-white overflow-hidden" data-testid="hero">
      <div
        className="absolute inset-0 ay-glow"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(45% 60% at 82% 12%, rgba(244,204,215,0.14), transparent 60%), radial-gradient(50% 70% at 12% 95%, rgba(217,185,110,0.14), transparent 60%)",
        }}
      />

      <div className="container-x relative pt-32 sm:pt-40 pb-16 lg:pb-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          {/* Copy */}
          <div className="lg:col-span-7 ay-hero-copy">
            <p className="eyebrow text-blush mb-6">
              Greensboro, North Carolina &amp; Surrounding Areas
            </p>

            <h1 className="text-[2.75rem] leading-[1.08] sm:text-6xl lg:text-[4.75rem] font-serif">
              Property Services,{" "}
              <span className="italic text-blush">Authentically</span> Done.
            </h1>

            <p className="mt-7 max-w-xl text-base sm:text-lg text-white/75 leading-relaxed">
              Professional residential and commercial cleaning, move-in/move-out
              services, and junk removal throughout Greensboro, NC and
              surrounding areas.
            </p>

            <p className="mt-6 eyebrow text-white/60 !tracking-[0.18em]">
              Residential &amp; Commercial &middot; Insured &middot; Free Estimates
            </p>

            <div className="mt-9 flex flex-col sm:flex-row flex-wrap gap-3">
              <Link to="/free-estimate" className="btn-primary" data-testid="hero-estimate">
                Get a Free Estimate
              </Link>
              <a href={TEL_HREF} className="btn-ghost btn-on-dark" data-testid="hero-call">
                <Phone size={16} strokeWidth={1.75} aria-hidden="true" /> Call {PHONE_DISPLAY}
              </a>
              <a href={SMS_HREF} className="btn-ghost btn-on-dark" data-testid="hero-text">
                <MessageSquareText size={16} strokeWidth={1.75} aria-hidden="true" /> Text Us
              </a>
            </div>
          </div>

          {/* Composition */}
          <div className="lg:col-span-5 ay-hero-art">
            <div className="relative mx-auto max-w-sm">
              <div className="absolute -inset-3 border border-gold/30" aria-hidden="true" />
              <div className="relative bg-[#100e10] border border-gold/20 px-8 py-12 flex flex-col items-center text-center">
                <img
                  src={LOGO_DARK}
                  alt="Authentically Yours Property Services logo"
                  width="260"
                  height="260"
                  className="w-52 sm:w-60 h-auto"
                  fetchPriority="high"
                />
                <span className="mt-6 font-script text-3xl text-blush">
                  Clean Spaces. Better Places.
                </span>
                <div className="mt-8 grid grid-cols-2 gap-px w-full bg-gold/20 border border-gold/20">
                  <div className="bg-[#100e10] py-4">
                    <p className="font-serif text-2xl text-blush">Insured</p>
                    <p className="eyebrow text-white/50 mt-1">Peace of Mind</p>
                  </div>
                  <div className="bg-[#100e10] py-4">
                    <p className="font-serif text-2xl text-blush">Free</p>
                    <p className="eyebrow text-white/50 mt-1">Estimates</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
